import axios from "axios";
import toast from 'react-hot-toast'
import translatedMessages, { defaultMessages } from "../components/Utils/translatedMessages";
import Logout from "../components/Settings/Logout";
import { history } from "../helpers/history";
export const defaultBackend = process.env.REACT_APP_URL_PLATESYS
export const useCookies = process.env.REACT_APP_USE_COOKIES

let timeout = 0

export const api = axios.create({
    baseURL: defaultBackend,
    timeout: 30000,
    withCredentials: true
})

// window.api = api

api.interceptors.request.use(async (config) => {
    if (useCookies === 'false') {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    }
    return config;
});

api.interceptors.response.use((response) => { return response },
    async function (err) {
        if (!err.response)
            return err;
        const response = err.response

        let responseMessage = defaultMessages['pt-BR']

        const errorMessage = response?.data?.detail

        if (errorMessage) {
            const transMessage = translatedMessages['pt-BR'][errorMessage]
            if (transMessage)
                responseMessage = transMessage
        }

        if (response.status === 500) {
            toast.error(responseMessage)
        }

        if (response.status === 401) {
            Logout(false)
            if ('invokeLogin' in window) window.invokeLogin(true)
            // if ('navigate' in history)
            //     history.navigate('/login')
            // else
            //     window.location.href = '/sistema/login'
            // clearTimeout(timeout)
            // timeout = setTimeout(() => toast.error('Você foi desconectado pois sua sessão expirou!'), 100)
        }

        return response;
    })

export const mediaURL = defaultBackend + '/media/'

export const createSession = async (username, password, engine) => {
    return api.post('/token/', { username, password, engine }, { timeout: 5000 })
}

export const getCredentials = async () => {
    return api.get('/integrations/')
}

